import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrClosing } from '../../../../../../../shared/types/modules/pqr';

export const usePqrNotificationClose = (closing?: PqrClosing) => {
    const formik = useFormik({
        initialValues: {
            emailNotification: false,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            emailNotification: closing?.emailNotification || false,
        });
    }, [closing]);

    return {
        formik,
    };
};
